import { gql } from '@apollo/client'

const GET_USER_CONFIG_QUERY = gql`
  query user {
    user {
      createdAt
      id
      firstName
      lastName
      email
      phone
      nonprofitExperienceRange
      permissions
      lastLoggedInAt
      spaces
    }
  }
`

export default GET_USER_CONFIG_QUERY
